"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_DeviceMetric = exports.DeviceMetricCategoryKind = exports.DeviceMetricColorKind = exports.DeviceMetricOperationalStatusKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_Timing_1 = require("./RTTI_Timing");
var RTTI_DeviceMetric_Calibration_1 = require("./RTTI_DeviceMetric_Calibration");
var DeviceMetricOperationalStatusKind;
(function (DeviceMetricOperationalStatusKind) {
    DeviceMetricOperationalStatusKind["_on"] = "on";
    DeviceMetricOperationalStatusKind["_off"] = "off";
    DeviceMetricOperationalStatusKind["_standby"] = "standby";
    DeviceMetricOperationalStatusKind["_enteredInError"] = "entered-in-error";
})(DeviceMetricOperationalStatusKind = exports.DeviceMetricOperationalStatusKind || (exports.DeviceMetricOperationalStatusKind = {}));
var DeviceMetricColorKind;
(function (DeviceMetricColorKind) {
    DeviceMetricColorKind["_black"] = "black";
    DeviceMetricColorKind["_red"] = "red";
    DeviceMetricColorKind["_green"] = "green";
    DeviceMetricColorKind["_yellow"] = "yellow";
    DeviceMetricColorKind["_blue"] = "blue";
    DeviceMetricColorKind["_magenta"] = "magenta";
    DeviceMetricColorKind["_cyan"] = "cyan";
    DeviceMetricColorKind["_white"] = "white";
})(DeviceMetricColorKind = exports.DeviceMetricColorKind || (exports.DeviceMetricColorKind = {}));
var DeviceMetricCategoryKind;
(function (DeviceMetricCategoryKind) {
    DeviceMetricCategoryKind["_measurement"] = "measurement";
    DeviceMetricCategoryKind["_setting"] = "setting";
    DeviceMetricCategoryKind["_calculation"] = "calculation";
    DeviceMetricCategoryKind["_unspecified"] = "unspecified";
})(DeviceMetricCategoryKind = exports.DeviceMetricCategoryKind || (exports.DeviceMetricCategoryKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_DeviceMetric = t.recursion('IDeviceMetric', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('DeviceMetric'),
            type: RTTI_CodeableConcept_1.RTTI_CodeableConcept
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: t.array(RTTI_Identifier_1.RTTI_Identifier),
            unit: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            source: RTTI_Reference_1.RTTI_Reference,
            parent: RTTI_Reference_1.RTTI_Reference,
            operationalStatus: (0, EnumType_1.createEnumType)(DeviceMetricOperationalStatusKind, 'DeviceMetricOperationalStatusKind'),
            _operationalStatus: RTTI_Element_1.RTTI_Element,
            color: (0, EnumType_1.createEnumType)(DeviceMetricColorKind, 'DeviceMetricColorKind'),
            _color: RTTI_Element_1.RTTI_Element,
            category: (0, EnumType_1.createEnumType)(DeviceMetricCategoryKind, 'DeviceMetricCategoryKind'),
            _category: RTTI_Element_1.RTTI_Element,
            measurementPeriod: RTTI_Timing_1.RTTI_Timing,
            calibration: t.array(RTTI_DeviceMetric_Calibration_1.RTTI_DeviceMetric_Calibration)
        })
    ]);
});
//# sourceMappingURL=RTTI_DeviceMetric.js.map